import angular from 'angular';

angular.module('commonServices').directive('focusOnChange', [
  '$timeout',
  function($timeout) {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        if (!ngModel) return;
        var selector = attrs.focusOnChange;
        if (!selector) {
          console.warn('focusOnChange: no selector specified');
          return;
        }
        ngModel.$viewChangeListeners.push(function() {
          $timeout(function() {
            $(selector)
              .filter(':visible')
              .first()
              .focus();
          }, 100);
        });
      },
    };
  },
]);
